<template>
  <div class="flex flex-row items-center" style="min-width: 300px;">
    <arrow-icn
      :class="[`${color}-icon`]"
      width="20"
      height="20"
      @click="prevYear"
    ></arrow-icn>
    <slot name="icon"> </slot>

    <span :class="['text-lg font-bold', `text-${color}`]"
      >{{ currentYear }}年度</span
    >
    <span :class="['text-lg', `text-${color}`]">｜{{ wareki }}</span>
    <arrow-icn
      width="20"
      height="20"
      :class="['ml-3 mr-3 transform rotate-180', `${color}-icon`]"
      @click="nextYear"
    ></arrow-icn>
  </div>
</template>

<script>
import ArrowIcn from '@/assets/icons/arrow.svg?inline'

import { useYearSelector } from '@/services/useYearSelector'

export default {
  name: 'AppYearSelector',

  components: {
    ArrowIcn,
  },

  props: {
    color: {
      type: String,
      default: '',
    },
  },

  setup() {
    return { ...useYearSelector() }
  },
}
</script>
